// extracted by mini-css-extract-plugin
module.exports = {"BGIcon":"RequiredDocuments-module__BGIcon","RDlistsContainer":"RequiredDocuments-module__RDlistsContainer"};